import React, { createContext, useState } from "react"
import { get, post, put } from "utils/apiClient"

// Update this path to match the API Gateway route for the cp_ui_address_jobs Lambda
const API_PATH = 'locations/addressmgmt'

const AddressMappingContext = createContext()

function Provider({ children }) {
    const [records, setRecords] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await get(`${API_PATH}?feature=jobs&job_type=address_mapping`)
            setRecords(response || [])
        } catch (err) {
            console.error(err)
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    const createJob = async (payload) => {
        return await post(`${API_PATH}?feature=upload-file`, payload)
    }

    const getRecord = async (jobId) => {
        return await get(`${API_PATH}?feature=job-detail&job_id=${jobId}`)
    }

    const refreshDownloadUrl = async (jobId) => {
        const response = await get(`${API_PATH}?feature=download-file&job_id=${jobId}`)
        return response?.download_url
    }

    const saveMappings = async (jobId, columnMappings) => {
        return await put(`${API_PATH}?feature=job-detail`, {
            job_id:          jobId,
            column_mappings: columnMappings,
        })
    }

    const uploadFileToS3 = async (presignedUrl, file) => {
        const response = await fetch(presignedUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        })
        if (!response.ok) throw new Error('File upload to S3 failed')
    }

    const valueToShare = {
        records,
        loading,
        error,
        setError,
        fetchRecords,
        createJob,
        getRecord,
        saveMappings,
        refreshDownloadUrl,
        uploadFileToS3,
    }

    return (
        <AddressMappingContext.Provider value={valueToShare}>
            {children}
        </AddressMappingContext.Provider>
    )
}

export { Provider }
export default AddressMappingContext
